var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pricing"},[_c('home-header'),_c('div',{staticClass:"contentWrap"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }